export default function App() {
  const siteName = import.meta.env.VITE_SITE_NAME || 'Colloïde';
  const contactEmail = import.meta.env.VITE_CONTACT_EMAIL || 'hello@colloide.io';

  return (
    <div className="site">
      <a className="skip-link" href="#main">Skip to content</a>

      <header className="header">
        <div className="container header-inner">
          <div className="brand">
            <span className="logo" aria-hidden>◯</span>
            <span className="brand-name">{siteName}</span>
          </div>
          <nav className="nav" aria-label="Primary">
            <a href="#services">Services</a>
            <a href="#about">About</a>
            <a href={`mailto:${contactEmail}`} className="nav-cta">Contact</a>
          </nav>
        </div>
      </header>

      <main id="main">
        <section className="hero">
          <div className="container">
            <h1>{siteName}</h1>
            <p className="tagline">Software at the speed of thought.</p>
            <div className="actions">
              <a className="button primary" href={`mailto:${contactEmail}`}>Start a conversation</a>
              <a className="button ghost" href="https://colloide.io" target="_blank" rel="noreferrer">Learn more</a>
            </div>
          </div>
        </section>

        <section id="services" className="section">
          <div className="container">
            <h2 className="section-title">What we do</h2>
            <div className="cards">
              <div className="card">
                <h3>Cloud & Platforms</h3>
                <p>Design, build, and scale reliable cloud services with modern DevOps.</p>
              </div>
              <div className="card">
                <h3>Data & AI</h3>
                <p>From pipelines to practical AI — insights and automation that ship.</p>
              </div>
              <div className="card">
                <h3>Product Engineering</h3>
                <p>Elegant web apps, from MVP to enterprise‑grade, built to last.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="section muted">
          <div className="container">
            <h2 className="section-title">About {siteName}</h2>
            <p>
              We are a software company focused on clarity, velocity, and craft. We partner with
              teams to deliver high‑impact software without the drag.
            </p>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container footer-inner">
          <p>© {new Date().getFullYear()} {siteName}</p>
          <p>
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
